// extracted by mini-css-extract-plugin
export default {"home":"Home_home__aTeC0","title-bar-icons":"Home_title-bar-icons__NGl4Y"};